/**
 * Sticker pack definitions for the Canvas Editor.
 * Phase 3: emoji-based sticker packs organized by culturally relevant categories.
 * Future: real PNG sticker assets served from CDN.
 */

export const STICKER_PACKS = [
  {
    key: 'vibes',
    label: 'Vibes',
    icon: '✨',
    stickers: [
      { key: 'fire',       emoji: '🔥', label: 'Fire' },
      { key: 'hundred',    emoji: '💯', label: 'Hundred' },
      { key: 'crown',      emoji: '👑', label: 'Crown' },
      { key: 'sparkles',   emoji: '✨', label: 'Sparkles' },
      { key: 'star',       emoji: '⭐', label: 'Star' },
      { key: 'diamond',    emoji: '💎', label: 'Diamond' },
      { key: 'rocket',     emoji: '🚀', label: 'Rocket' },
      { key: 'lightning',  emoji: '⚡', label: 'Lightning' },
      { key: 'trophy',     emoji: '🏆', label: 'Trophy' },
      { key: 'medal',      emoji: '🥇', label: 'Medal' },
      { key: 'money-bag',  emoji: '💰', label: 'Money Bag' },
      { key: 'money-wings',emoji: '💸', label: 'Money Wings' },
    ],
  },
  {
    key: 'culture',
    label: 'Culture',
    icon: '✊🏾',
    stickers: [
      { key: 'fist',       emoji: '✊🏾', label: 'Fist' },
      { key: 'raised',     emoji: '🙌🏾', label: 'Raised' },
      { key: 'clap',       emoji: '👏🏾', label: 'Clap' },
      { key: 'prayer',     emoji: '🙏🏾', label: 'Prayer' },
      { key: 'wave',       emoji: '👋🏾', label: 'Wave' },
      { key: 'flex',       emoji: '💪🏾', label: 'Flex' },
      { key: 'point-up',   emoji: '☝🏾', label: 'Point Up' },
      { key: 'heart-hands',emoji: '🫶🏾', label: 'Heart Hands' },
      { key: 'pinch',      emoji: '🤌🏾', label: 'Pinch' },
      { key: 'salute',     emoji: '🫡', label: 'Salute' },
      { key: 'black-heart',emoji: '🖤', label: 'Black Heart' },
      { key: 'africa',     emoji: '🌍', label: 'Africa' },
    ],
  },
  {
    key: 'mood',
    label: 'Mood',
    icon: '😤',
    stickers: [
      { key: 'crying',     emoji: '😭', label: 'Crying' },
      { key: 'skull',      emoji: '💀', label: 'Dead' },
      { key: 'side-eye',   emoji: '👀', label: 'Side Eye' },
      { key: 'sus',        emoji: '🤨', label: 'Sus' },
      { key: 'huff',       emoji: '😤', label: 'Huff' },
      { key: 'nerd',       emoji: '🤓', label: 'Nerd' },
      { key: 'cold',       emoji: '🥶', label: 'Cold' },
      { key: 'hot',        emoji: '🥵', label: 'Hot' },
      { key: 'shush',      emoji: '🤫', label: 'Shush' },
      { key: 'mindblown',  emoji: '🤯', label: 'Mind Blown' },
      { key: 'cap',        emoji: '🧢', label: 'Cap' },
      { key: 'clown',      emoji: '🤡', label: 'Clown' },
    ],
  },
  {
    key: 'drip',
    label: 'Drip',
    icon: '🔮',
    stickers: [
      { key: 'sunglasses', emoji: '😎', label: 'Sunglasses' },
      { key: 'nail',       emoji: '💅🏾', label: 'Nail' },
      { key: 'lips',       emoji: '💋', label: 'Lips' },
      { key: 'eyes-stars', emoji: '🤩', label: 'Stars' },
      { key: 'mirror',     emoji: '🪞', label: 'Mirror' },
      { key: 'crystal',    emoji: '🔮', label: 'Crystal Ball' },
      { key: 'perfume',    emoji: '🧴', label: 'Perfume' },
      { key: 'ring',       emoji: '💍', label: 'Ring' },
      { key: 'shoe',       emoji: '👟', label: 'Sneaker' },
      { key: 'handbag',    emoji: '👜', label: 'Bag' },
      { key: 'dress',      emoji: '👗', label: 'Dress' },
      { key: 'hoodie',     emoji: '🧥', label: 'Fit' },
    ],
  },
  {
    key: 'food',
    label: 'Eats',
    icon: '🍗',
    stickers: [
      { key: 'chicken',    emoji: '🍗', label: 'Chicken' },
      { key: 'taco',       emoji: '🌮', label: 'Taco' },
      { key: 'rice',       emoji: '🍚', label: 'Rice' },
      { key: 'hot-pepper', emoji: '🌶️', label: 'Pepper' },
      { key: 'watermelon', emoji: '🍉', label: 'Watermelon' },
      { key: 'mango',      emoji: '🥭', label: 'Mango' },
      { key: 'coconut',    emoji: '🥥', label: 'Coconut' },
      { key: 'avocado',    emoji: '🥑', label: 'Avocado' },
      { key: 'cake',       emoji: '🎂', label: 'Cake' },
      { key: 'coffee',     emoji: '☕', label: 'Coffee' },
      { key: 'cocktail',   emoji: '🍹', label: 'Cocktail' },
      { key: 'champagne',  emoji: '🍾', label: 'Champagne' },
    ],
  },
  {
    key: 'music',
    label: 'Music',
    icon: '🎵',
    stickers: [
      { key: 'music-note', emoji: '🎵', label: 'Notes' },
      { key: 'headphones', emoji: '🎧', label: 'Headphones' },
      { key: 'mic',        emoji: '🎤', label: 'Mic' },
      { key: 'guitar',     emoji: '🎸', label: 'Guitar' },
      { key: 'drum',       emoji: '🥁', label: 'Drum' },
      { key: 'speaker',    emoji: '🔊', label: 'Speaker' },
      { key: 'vinyl',      emoji: '💿', label: 'Vinyl' },
      { key: 'radio',      emoji: '📻', label: 'Radio' },
      { key: 'dancing-m',  emoji: '🕺🏾', label: 'Dance' },
      { key: 'dancing-f',  emoji: '💃🏾', label: 'Dance' },
      { key: 'party',      emoji: '🎉', label: 'Party' },
      { key: 'confetti',   emoji: '🎊', label: 'Confetti' },
    ],
  },
];

/**
 * Search stickers across all packs.
 * Returns flat array of matching stickers with pack info.
 */
export function searchStickers(query) {
  if (!query || query.length < 2) return [];
  const q = query.toLowerCase();
  const results = [];
  for (const pack of STICKER_PACKS) {
    for (const sticker of pack.stickers) {
      if (sticker.label.toLowerCase().includes(q) || sticker.key.includes(q)) {
        results.push({ ...sticker, packKey: pack.key, packLabel: pack.label });
      }
    }
  }
  return results;
}
